import { jsx, type JsxElementProps } from '@amazon/vinyl-tsx'
import { type ObservableValue } from '@amazon/vinyl-observable'
import type { AmazonPlaybackQuality, AmznTrackType } from '@amzn/vinyl-amzn'

const goldQualities: AmznTrackType[] = ['HD', 'UHD', '3D']

/**
 * CSS classes for different badge styles.
 */
enum BadgeStyle {
    NONE = 'hiddenBadge',
    GOLD = 'goldBadge',
    SILVER = 'silverBadge',
}

function getBadgeStyle(quality: AmazonPlaybackQuality | null): BadgeStyle {
    if (!quality) return BadgeStyle.NONE
    else if (goldQualities.includes(quality.trackType)) return BadgeStyle.GOLD
    else return BadgeStyle.SILVER
}

export type QualityBadgeProps = JsxElementProps<'div'> & {
    data: ObservableValue<AmazonPlaybackQuality | null>
}

export function QualityBadge(props: QualityBadgeProps) {
    return (
        <div
            className="qualityBadge"
            tabIndex={0}
            role="button"
            aria-label={props.data.map((q) =>
                q?.trackType ? `Audio quality: ${q.trackType}. Open nerd stats.` : 'Open nerd stats'
            )}
            {...props}
            classList={[props.data.map(getBadgeStyle)]}
        >
            {props.data.map((quality) => quality?.trackType ?? ' ')}
        </div>
    )
}
